import { useButton } from '@react-aria/button'
import { useFocusRing } from '@react-aria/focus'
import { useHover } from '@react-aria/interactions'
import { filterDOMProps, mergeProps } from '@react-aria/utils'
import cx from 'classnames'
import { forwardRef } from 'react'
import { useObjectRef } from 'utils/useObjectRef'
import { ButtonProps } from './Types'
import Styles from './FloatingButton.module.scss'

export const FloatingButton = forwardRef<HTMLButtonElement, ButtonProps>((props, fRef) => {
  const ref = useObjectRef<HTMLButtonElement>(fRef)
  const { buttonProps, isPressed } = useButton(props, ref)
  const { hoverProps, isHovered } = useHover(props)
  const { isFocusVisible, focusProps } = useFocusRing()
  const { children, icon: Icon, isDisabled, position = 'right', offset = 0, variant = 'primary', ...finalProps } = props

  const positionStyle = position === 'left' ? { left: `${10 + offset}px` } : { right: `${10 + offset}px` }

  return (
    <button
      aria-label={props.title}
      {...mergeProps(filterDOMProps(finalProps), buttonProps, hoverProps, focusProps)}
      className={cx(Styles.root, Styles[position], Styles[variant], {
        [Styles.focused]: isFocusVisible,
        [Styles.pressed]: isPressed,
        [Styles.hovered]: isHovered,
      })}
      ref={ref}
      style={positionStyle}
    >
      <Icon />
    </button>
  )
})
